const Form4 = ({ state, changeHandler, loading, nextHandler, prevHandler }) => {
  const clickHandler = (title) => {
    changeHandler({
      activity: title
    });
    nextHandler();
  }
  const data = [
    {
      title: 'Not Very Active',
      desc: 'Spend most of the day sitting (e.g., bankteller, desk job). '
    },
    {
      title: 'Lightly Active',
      desc: 'Spend a good part of the day on your feet(e.g., teacher, salesperson). '
    },
    {
      title: 'Active',
      desc: 'Spend a good part of the day doing some physical activity (e.g., food server, postal carrier). '
    },
    {
      title: 'Very Active',
      desc: 'Spend a good part of the day doing heavy physical activity (e.g., bike messenger, carpenter). '
    }
  ]
  return(
    <div className="programsContainer programsContainer4">
        <div className="fo-26 bco text-center fw-700 mfo-22">What's your Activity level?</div>
        <div className="row m-0 mt-4 activitySelection">
          {
            data.map(elem => <Card key={elem.title} data={elem} clickHandler={clickHandler}/>)
          }
        </div>
    </div>
  )
}

export default Form4;


const Card = ({ data, clickHandler }) => {
  return(
    <div className="col-6 col-sm-6 m-auto text-center mb-4" onClick={() => clickHandler(data.title)}>
      <div className="activityDiv">
        <div className='text-white fo-20 fw-600 cmfo-16'>{ data.title }</div>
        <div className='text-white fo-14 cmfo-12'>{ data.desc }</div>
      </div>
    </div>
  )
}
